import { Decoder, field, number, string, succeed } from 'jsonous';
import { StaffPresenceMember } from './Types';

export const staffPresenceMemberDecoder: Decoder<StaffPresenceMember> = succeed({})
  .assign('id', field('id', number))
  .assign('shortName', field('short_name', string));
